import React from 'react';

import { ServiceAreaWrapperV1 } from './ServiceAreaWrapperV1';
import { ServiceAreaWrapperV2 } from './ServiceAreaWrapperV2';

type Props = {
  children: React.ReactNode;
  enabledV2: boolean;
};

export const ServiceAreaWrapper = ({ children, enabledV2 }: Props) => {
  if (enabledV2) return <ServiceAreaWrapperV2>{children}</ServiceAreaWrapperV2>;

  return <ServiceAreaWrapperV1>{children}</ServiceAreaWrapperV1>;
};
